import React from 'react';
import { RiDeleteBinLine } from 'react-icons/ri';

import { useDeleteConfMutation, useGetParticipantsListQuery, useDeleteParticipantMutation } from '../../services/RttBridgeApi';

interface DeleteConfProps {
    conferenceId: string;
    updateSelectedConf: () => void;
}

const DeleteConf: React.FC<DeleteConfProps> = ({ conferenceId, updateSelectedConf }) => {
    const [deleteConf] = useDeleteConfMutation()
    const [deleteParticipant] = useDeleteParticipantMutation();
    const { data: partList } = useGetParticipantsListQuery({ id: conferenceId });

    // Declare a function for making the API request to delete a conference with the given ID
    const handleDeleteConf = async () => {
        try {
            if (partList?.participants.length > 0) {
                for (const participant of partList.participants) {
                    await deleteParticipant({ info: { cId: conferenceId, pId: participant.id } }).unwrap();
                }
            }

            await deleteConf({ id: conferenceId }).unwrap();
            // Call the updateSelectedConf function after the conference is deleted
            updateSelectedConf();
        } catch (error) {
            console.error('Error deleting conference and participants:', error);
        }
    };

    return (
        <>
            <button onClick={handleDeleteConf} className='delete-button round-button'>
                <RiDeleteBinLine className='icon' />
            </button>
        </>
    );
};

export default DeleteConf;